import React, {useMemo, useState} from "react";
import {Autocomplete, InputAdornment, TextField} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

export default function SearchField({industrieObjects, handleFlyToIndustrieObjects, onChange, onCompanySelect}) {
  const [value, setValue] = useState(null);
  const navigate = useNavigate();

  const {t} = useTranslation()

  const handleInputChange = (event, newValue) => {
    onChange(newValue)
  };

  const handleChange = (event, newValue) => {
    if (typeof newValue === 'string') return;
    setValue(newValue)
    if (newValue) {
      const objects = newValue.industrieObjects;
      if (objects.length === 1) {
        handleFlyToIndustrieObjects(objects)
        if (objects[0].SeoCanonicalURL) {
          navigate(`/${objects[0].SeoCanonicalURL}`);
        }
      }
      onCompanySelect?.()
    }
  };

  const groupedByCompany = useMemo(() => {
    return industrieObjects.reduce((acc, item) => {
      const company = item.Company;
      if (!acc[company]) {
        acc[company] = [];
      }
      acc[company].push(item);
      return acc;
    }, {});
  }, [industrieObjects]);

  const companyOptions = useMemo(() => {
    return Object.entries(groupedByCompany).map(([company, objects]) => ({
      Company: company,
      industrieObjects: objects,
    }));
  }, [groupedByCompany]);

  return (
    <Autocomplete
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: 0,
          backgroundColor: '#EDF4F9',
          paddingLeft: '4px',
          transition: 'all 0.2s ease',
          '& fieldset': {
            borderColor: '#CCDBE6',
            transition: 'border-color 0.2s ease',
          },
          '&:hover fieldset': {
            borderColor: '#0063a6',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#0063a6',
            borderWidth: 2,
          },
        },
      }}
      freeSolo
      fullWidth
      onInputChange={handleInputChange}
      onChange={handleChange}
      isOptionEqualToValue={(option, value) => option.Company === value.Company}
      getOptionLabel={(option) => typeof option === 'string' ? option : option.Company}
      options={companyOptions}
      value={value}
      popupIcon={null}
      filterOptions={(x) => x}
      noOptionsText={t('filters.field_name_search_not_found')}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={t('filters.field_name_search')}
          variant="outlined"
          slotProps={{
            input: {
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: '#0063a6', ml: 0.5 }} />
                </InputAdornment>
              ),
            },
          }}
        />
      )}
    />
  );
}
